import { useSiteContent } from '@/hooks/useSiteContent';
import ContentState from '@/components/feature/ContentState';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface FinalCTAData {
  headline: string;
  subheadline: string;
  description: string;
  cta: string;
  secondaryCta: string;
}

export default function FinalCTA() {
  const { data, loading, error, refresh } = useSiteContent<FinalCTAData>('why_us_final_cta');
  const { t } = useTranslation();

  if (loading || error || !data) {
    return <ContentState loading={loading} error={error} ready={!!data} onRetry={refresh} />;
  }

  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vietnam%20Ha%20Long%20Bay%20aerial%20view%20at%20golden%20sunset%2C%20traditional%20junk%20boats%20sailing%20among%20limestone%20karsts%2C%20warm%20orange%20and%20teal%20color%20palette%2C%20cinematic%20travel%20photography%2C%20dramatic%20lighting%2C%20editorial%20quality&width=1600&height=700&seq=whyus-cta-bg&orientation=landscape"
          alt={t('whyus.finalCtaAlt')}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/60" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2">
            {data.headline}
          </h2>
          <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-white/90 mb-6">
            {data.subheadline}
          </h3>
          <p className="text-base md:text-lg text-white/80 max-w-xl mx-auto mb-8 leading-relaxed">
            {data.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/tours"
              className="bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3.5 rounded-lg transition-colors whitespace-nowrap text-base"
            >
              {data.cta}
            </Link>
            <Link
              to="/tours"
              className="border border-white/40 hover:border-white/70 text-white font-semibold px-8 py-3.5 rounded-lg transition-colors whitespace-nowrap text-base"
            >
              {data.secondaryCta}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}